import { signInWithEmailAndPassword} from "firebase/auth";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import  { auth } from "./firebase";
import LocalStorage2 from "./LocalStorage2";
import UseLocalStorage from "./UseLocalStorage";
import { CircularProgress } from '@mui/material';


 
const UserDetails = (props) => {

    const [userEmail,setEmail] = UseLocalStorage('name',"");
    const [userID,setUserID] = LocalStorage2('id',"");
    const [IsLoading, setIsLoading] = useState(false);
 
    const [err,setErr] = useState();

  
     const navigate = useNavigate();

    // const handleChange = (e) =>{
    //     setUserName(e.target.value);
    // };

    const Proceed = async(e)=>{
        e.preventDefault();
     
      //  props.userID(userID);
      
       
       const email = e.target[0].value;
       const password = e.target[1].value;
       setIsLoading(true);
 
           try{
            await signInWithEmailAndPassword(auth,email,password);
        //    const res =  await signInWithEmailAndPassword(auth,email,password);
        //    console.log(res); 
        //    setUserName(res.user.displayName);
           
        // props.onSubmit(userName);
        setIsLoading(false);
        navigate("/OnlineRadio");

           }catch (err){
            setIsLoading(false);
            if(err.code === "auth/user-not-found"){
                setErr("User not found.");
              }else{
                setErr(`${userEmail} may have been blocked by the HBR Team.`)
              }
           }
    };

    // const handleSubmit = async (e) =>{
    //     e.preventDefault();
    //     const NameOfUser = e.target[0].value;
    //     const email = e.target[1].value;
    //     const password = e.target[2].value;


    //     try{
         
    //      const res = await createUserWithEmailAndPassword(auth,email,password)
    //     setRegister(false);
       

    //     await updateProfile(res.user,{
    //         displayName: NameOfUser,
    //     });

    //     await setDoc(doc(db,'user',res.user.uid), {
    //         uid: res.user.uid,
    //         email,
    //         userName: NameOfUser,
            
    //     });


    //     }catch (err){
    //        setErr(true);
    //     }
    // };

    return ( 
    <div className="User-Details">
           <form onSubmit={Proceed}>    
            {/* <input type="text" placeholder="enter your name" required value={userName} onChange = {handleChange} /> */}
            {IsLoading && <div> <CircularProgress color="secondary"/> </div>}
            <input type="email" placeholder="enter your email" required value={userEmail} onChange={e => setEmail(e.target.value)}/>
            <input type="password" placeholder="password" required value={userID} onChange={e => setUserID(e.target.value)}/>
            {/* <input type="text" placeholder="userID" onChange={e => setUserName(e.target.value)}></input> */}
            <button type="submit">Proceed</button> 
            <p id="haveRegistered">If you don't have account? <Link to="/Register">Click here to Register</Link> </p>
             <p id="readterms">Make sure you read the Terms of use before proceeding. <Link to="/AboutPage">Terms of Use</Link></p>
             <br/>
             {err && <p>{err} Contact the developers if error persist.<a href='mailto:ransadm23@gmail.com'>Mail us?</a></p>}
         
            </form>

             {/* {register && 
             <form onSubmit={handleSubmit}>
                <input type="text" placeholder="enter your name" required/>
                  <input type="email" placeholder="enter a valid name" required />
            <input type="password" placeholder="password" required/>
            <button type="submit">Register</button> 
                
            </form>} */}
         
        
    </div> 
    );
}
export default UserDetails;

 
